import { InboxOutlined } from "@ant-design/icons";
import { Button, Switch, Upload, UploadProps } from "antd";
import SigCanvas from "components/foundation/modal/SigCanvasModal";
import React, { useState } from "react";
import { getImageSrc } from "utils/format/imageUtils";

const { Dragger } = Upload;

interface ImgDetailProps {
  img: string;
  altText?: string;
  field?: any;
  onClick?: (value: any, field: any) => void;
  onClose?: () => void;
  type?: "img" | "sign";
}

const ImgDetail: React.FC<ImgDetailProps> = ({
  img,
  altText = "Image",
  field = "",
  onClick,
  onClose,
  type = "img",
}) => {
  const [uploadedFile, setUploadedFile] = useState<string | null>(null);
  const [uploadSuccess, setUploadSuccess] = useState<boolean>(false);
  const [fileName, setFileName] = useState<string | null>(null);
  const [isDrawMode, setIsDrawMode] = useState<boolean>(true);

  const handleUpload = ({ file, onSuccess, onError }: any) => {
    try {
      const reader = new FileReader();

      reader.onload = () => {
        const base64String = reader.result as string;
        setUploadedFile(base64String);

        setFileName(file.name);

        setUploadSuccess(true);
        onSuccess("Upload Successful");
      };

      reader.onerror = () => {
        setUploadSuccess(false);
        onError("Failed to upload");
      };

      reader.readAsDataURL(file);
    } catch (error) {
      setUploadSuccess(false);
    }
  };

  const uploadProps: UploadProps = {
    name: "file",
    accept: "image/*",
    showUploadList: false,
    customRequest: handleUpload,
    multiple: false,
  };

  const handleConfirmBulk = () => {
    if (uploadedFile) {
      if (onClick) {
        onClick(uploadedFile, field);
        onClose?.();
      }
    }
  };

  const handleSign = (value: any) => {
    if (value) {
      if (onClick) {
        onClick(value, field);
        onClose?.();
      }
    }
  };

  if (img && img.trim() !== "") {
    const src = getImageSrc(img);

    return (
      <div className="flex justify-center p-[10px]">
        <img
          src={src}
          alt={altText}
          style={{
            maxWidth: "100%",
            height: "400px",
            border: "1px solid #ccc",
            borderRadius: "8px",
          }}
        />
      </div>
    );
  }

  return (
    <div className="text-center p-[10px]">
      {type === "sign" && (
        <div className="mb-4 ">
          <Switch
            checkedChildren="Ký tay"
            unCheckedChildren="Tải ảnh"
            onChange={(checked) => {
              setIsDrawMode(checked);
              setUploadedFile(null);
              setUploadSuccess(false);
            }}
            checked={isDrawMode}
          />
        </div>
      )}

      {type === "sign" && isDrawMode && (
        <SigCanvas onClose={onClose} onOk={handleSign} />
      )}

      {(type !== "sign" || (type === "sign" && !isDrawMode)) && (
        <>
          {!uploadSuccess && (
            <Dragger {...uploadProps} style={{ padding: "40px 0" }}>
              <InboxOutlined style={{ fontSize: 48, color: "#999" }} />
              <p>Kéo thả hoặc click để chọn ảnh</p>
            </Dragger>
          )}

          {uploadedFile && uploadSuccess && (
            <div
              style={{
                alignItems: "center",
                flexDirection: "column",
                display: "flex",
              }}
            >
              <img
                src={uploadedFile}
                alt="Uploaded Image"
                style={{
                  width: "100%",
                  maxHeight: 300,
                  objectFit: "contain",
                  border: "1px solid #ccc",
                  borderRadius: "8px",
                }}
              />
              <p className="mt-[10px]">{fileName}</p>
            </div>
          )}

          <Button
            type="primary"
            block
            disabled={!uploadedFile}
            className="mt-4"
            onClick={handleConfirmBulk}
          >
            Xác nhận đăng ký
          </Button>
        </>
      )}
    </div>
  );
};

export default ImgDetail;
